var _circle, _circle2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E6EBF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    fill: "white",
    stroke: "#19B3B5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9447 34.2263C25.1143 34.574 25.2961 34.9071 25.4902 35.2256H13.1367V31.5226C13.1367 30.7914 13.3244 30.1055 13.7024 29.4607C14.078 28.82 14.5949 28.3361 15.2574 28.0049L15.2574 28.0049L15.2592 28.004C16.4424 27.4008 17.7797 26.8887 19.2722 26.4689C20.753 26.0525 22.3887 25.843 24.1812 25.843H24.6753C24.7 25.843 24.7248 25.8439 24.7496 25.8457C24.6083 26.1927 24.4857 26.5506 24.3817 26.9193C24.2681 27.3223 24.1767 27.7382 24.1075 28.1667C22.4453 28.1729 20.9437 28.3873 19.6051 28.8137C18.2686 29.2395 17.1671 29.6676 16.3044 30.0989L16.3043 30.0987L16.2948 30.104C16.0444 30.2431 15.8425 30.4386 15.6911 30.6863C15.5367 30.939 15.4603 31.2198 15.4603 31.5226V32.652V32.902H15.7103H24.4183C24.5564 33.3488 24.732 33.7903 24.9447 34.2263ZM24.1812 23.9312C22.695 23.9312 21.429 23.4049 20.3696 22.3455C19.3102 21.2861 18.7839 20.0201 18.7839 18.5339C18.7839 17.0478 19.3102 15.7818 20.3696 14.7224C21.429 13.663 22.695 13.1367 24.1812 13.1367C25.6673 13.1367 26.9333 13.663 27.9927 14.7224C29.0521 15.7818 29.5784 17.0478 29.5784 18.5339C29.5784 20.0201 29.0521 21.2861 27.9927 22.3455C26.9333 23.4049 25.6673 23.9312 24.1812 23.9312ZM24.1812 21.6076C25.0245 21.6076 25.7526 21.3044 26.3521 20.7049C26.9516 20.1054 27.2548 19.3773 27.2548 18.5339C27.2548 17.6906 26.9516 16.9625 26.3521 16.363C25.7526 15.7635 25.0245 15.4603 24.1812 15.4603C23.3378 15.4603 22.6097 15.7635 22.0102 16.363C21.4107 16.9625 21.1076 17.6906 21.1076 18.5339C21.1076 19.3773 21.4107 20.1054 22.0102 20.7049C22.6097 21.3044 23.3378 21.6076 24.1812 21.6076Z",
    fill: "#19B3B5",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8236 35.8202L33.8184 32.6437L31.706 30.5261L33.8184 28.4031L33.8236 25.2319H27.4707V28.4084L29.5884 30.5261L27.4707 32.6384V35.8202H33.8236Z",
    fill: "#19B3B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5293 26.2905V27.7729L30.6469 29.467L32.7646 27.7729V26.2905H28.5293Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.080c3569bb59e51d4296bb295782fe22.svg";
export { ForwardRef as ReactComponent };